import { filterOptions } from '@/utils/query-base'

const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'xuhao': {
    title: '排名',
    type: 'number',
    equation: cusname,
    width: 80
  },
  'cust_name': {
    title: '订单客户名称',
    type: 'input',
    equation: cusname,
    width: 250
  },
  'zzfld00001h': {
    describe: true,
    title: '营销单元(订单客户)',
    type: 'select',
    equation: all,
    dictionary: 'sale',
    width: 160
  },
  'zzfld00003e': {
    describe: true,
    title: '基地(订单客户)',
    type: 'select',
    equation: all,
    dictionary: 'base',
    width: 160
  },
  'ycate': {
    describe: true,
    title: '品牌(月报分类)',
    type: 'select',
    equation: city,
    dictionary: 'A0016',
    width: 150
  },
  'zzfld000001': {
    describe: true, // 描述 _text 添加属性
    title: '营销单元', // 字段名称
    type: 'select', // 输入类型 下拉
    equation: all, // 条件
    dictionary: 'sale' // 字典 （营销单元(sale)， 基地(base)，省(region)，市(city)，区(street)）
  },
  'zzfld000002': {
    describe: true,
    title: '省份',
    type: 'select',
    equation: be,
    dictionary: 'region'
  },
  'zzfld000003': {
    describe: true,
    title: '城市',
    type: 'select',
    equation: city,
    dictionary: 'city'
  },
  'use_dun': {
    title: '开票量(吨)',
    xlsxFmt: {
      t: 'n',
      z: '0.00000000'
    }
  },
  'pure_value': {
    title: '开票金额(万元)',
    xlsxFmt: {
      t: 'n',
      z: '0.000000'
    }
  }
}




// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/dealersRankingReportForms.js